import { useState, useEffect } from 'react';

export function Countdown({ target, testId }) {
  const calc = () => {
    const diff = new Date(target).getTime() - Date.now();
    if (diff <= 0) return null;
    return {
      d: Math.floor(diff / 86400000),
      h: Math.floor((diff / 3600000) % 24),
      m: Math.floor((diff / 60000) % 60),
    };
  };
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 60000);
    return () => clearInterval(id);
  }, [target]);

  if (!t) return null;
  const Cell = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <span className="font-mono text-lg text-gold">{String(v).padStart(2, '0')}</span>
      <span className="text-[10px] uppercase tracking-wider text-muted-foreground">{l}</span>
    </div>
  );
  return (
    <div data-testid={testId} className="flex items-center gap-4">
      <Cell v={t.d} l="Days" /><Cell v={t.h} l="Hrs" /><Cell v={t.m} l="Min" />
    </div>
  );
}
